import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import adminService from '../services/adminService';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    try {
      const cached = localStorage.getItem('authUser');
      if (cached) {
        try {
          const parsed = JSON.parse(cached);
          if (parsed && typeof parsed === 'object') {
            setUser(parsed);
          } else {
            setUser({ username: String(cached || '') });
          }
        } catch (_) {
          setUser({ username: String(cached || '') });
        }
      }
    } catch (_) {}
  }, []);

  const login = async (username, password) => {
    try {
      const admins = await adminService.getListData();
      const list = Array.isArray(admins) ? admins : [];
      const found = list.find(a => !a?.isDeleted && a.username === username && a.password === password);
      if (found) {
        const nextUser = { username: found.username, role: found.role || 'a' };
        setUser(nextUser);
        try { localStorage.setItem('authUser', JSON.stringify(nextUser)); } catch (_) {}
        return { ok: true };
      }
      return { ok: false, message: 'Invalid username or password' };
    } catch (e) {
      return { ok: false, message: 'Login failed' };
    }
  };

  const logout = () => {
    setUser(null);
    try { localStorage.removeItem('authUser'); } catch (_) {}
  };

  const value = useMemo(() => ({
    user,
    isAuthenticated: !!user,
    login,
    logout,
  }), [user]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
